const fileConfig = {
  applicationMaxFileUploadSize: 30,
};

export default fileConfig;
